import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=2563ed0a&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/homePage.scss?vue&type=style&index=0&id=2563ed0a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563ed0a",
  null
  
)

export default component.exports